import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { SyncConfigService } from 'src/app/core/services/sync-config.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  count: number = 5;
  countDecrementSub: Subscription;

  constructor(private router: Router,
    private syncConfig: SyncConfigService) { }
  
  ngOnInit(): void {
    this.countDecrementSub = interval(this.syncConfig.config.extras.notFoundCounter).subscribe(x => {
      this.count = this.count - 1;
      if(this.count === 0){
        this.router.navigate(['/']);
        this.countDecrementSub.unsubscribe();
      }
    });
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.countDecrementSub.unsubscribe();
  }

}
